import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Container,
  Link,
  Flex,
  Image,
  Typography,
  useThemedValueSwitch,
} from '@tq/ui-components';

import { CUSTOM_TQ_COLOURS } from 'styles';
import TQPoweredByLogo from 'assets/tq-powered-by-logo.svg';

export const Copyright: React.FC = () => {
  const { t } = useTranslation('footer');

  const { isTQ, tvs } = useThemedValueSwitch();

  return (
    <Box
      sx={{
        pt: tvs({ tq: '2rem', ni: { base: '1.875rem', md: '2.5rem', lg: '2.375rem' } }),
        pb: tvs({ tq: '3.75rem', ni: { base: '2.25rem', md: '3rem', lg: '2.375rem' } }),
        backgroundColor: tvs({ tq: CUSTOM_TQ_COLOURS.blue072C4D, ni: 'blue.700' }),
      }}
    >
      <Container>
        <Flex
          flexWrap={{ base: 'wrap', lg: 'nowrap' }}
          justifyContent={{
            base: tvs({ tq: 'space-between', ni: 'flex-start' }),
            lg: tvs({ ni: 'center' }),
          }}
          alignItems={'center'}
        >
          <Typography
            sx={{
              flexBasis: { base: '100%', lg: '60%' },
              alignItems: 'center',
              mb: { base: '1.75rem', md: '1.25rem', lg: 0 },
              fontSize: { base: 'xs', md: 'sm' },
              lineHeight: 'short',
              letterSpacing: '-0.2px',
              color: 'white',
            }}
          >
            {isTQ ? (
              'The Consultee Exchange Centre is developed and powered by TerraQuest. All content © 2023 Consultee Exchange Centre'
            ) : (
              <>
                {t(
                  'copyright',
                  'The Consultee Hub is developed and powered by TerraQuest. All content ©'
                )}{' '}
                {`${new Date().getFullYear()} Consultee Hub`}
              </>
            )}
          </Typography>
          <Flex
            flexBasis={{ base: '100%', lg: 'auto' }}
            justifyContent={{ base: 'flex-start', lg: 'center' }}
          >
            <Link
              href='https://www.terraquest.co.uk'
              target='_blank'
              ml={{ lg: '2rem' }}
              sx={{
                border: '1px solid',
                borderColor: 'transparent',
                display: 'inline-block',
                _focus: {
                  border: '1px solid',
                  borderColor: 'blue.300',
                  borderRadius: '4px',
                  boxShadow: '0 0 3px 2px #2182EB',
                },
              }}
            >
              <Image
                src={TQPoweredByLogo}
                w={{ base: '8.7rem', md: '10.9rem' }}
                h={{ base: '2.5rem', md: '2.5rem' }}
                alt={t('tq_logo_alt', 'Terraquest hub logo')}
                objectFit='contain'
              />
            </Link>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};
